import React from 'react'
import { Alert } from 'reactstrap'

/**
 * alerts: [
 *  {
 *    show: Boolean -> Instead of delete the object to hide the alert, just set show: false
 *    color: String -> Could be info|warning|danger
 *    message: html -> It's html but need to be wrapped in <> </>. If <a> tag is target='_blank', it have to have rel="noopener noreferrer" too
 *   }
 * ]
 */

const alerts = [
  {
    show: false,
    color: 'danger',
    message: <>SureDone is currently experiencing issues due to an outage at Amazon AWS. Please see <a href='https://status.suredone.com/' target='_blank' rel='noopener noreferrer'>https://status.suredone.com</a> for further information.</>
  }
]

export const LoginAlerts = () => {
  return alerts.map(({ show, color, message }, i) => (show &&
    <Alert
      key={message}
      color={color}
      className='text-center mb-0'
      style={{ position: 'sticky', top: 0, width: '100%' }}
    >
      {message}
    </Alert>
  ))
}
